module.exports = __webpack_public_path__ + "static/img/Gold_badge.7904051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Gold_badge.png
// module id = 983
// module chunks = 1